// Shared post-processing utilities (used in main scanner and lab).

// Remove dark background pixels → white, apply brightness+contrast to foot pixels.
// threshold: luminance cutoff (pixels below → background)
// brightness/contrast: same -100..100 scale as scanner hardware settings
export function removeDarkBackground(base64, { threshold = 19, brightness = 33, contrast = 94 }) {
  return new Promise(resolve => {
    const img = new Image();
    img.onload = () => {
      const c = document.createElement("canvas");
      c.width = img.naturalWidth; c.height = img.naturalHeight;
      const ctx = c.getContext("2d");
      ctx.drawImage(img, 0, 0);
      const d = ctx.getImageData(0, 0, c.width, c.height);
      const px = d.data;

      const lums = new Float32Array(px.length / 4);
      for (let i = 0; i < px.length; i += 4)
        lums[i / 4] = px[i] * 0.299 + px[i+1] * 0.587 + px[i+2] * 0.114;

      const isBg = new Uint8Array(px.length / 4);
      for (let i = 0; i < lums.length; i++)
        if (lums[i] < threshold) isBg[i] = 1;

      const bf = brightness * 2.55;
      const cf = contrast !== 0 ? (259 * (contrast + 255)) / (255 * (259 - contrast)) : 1;
      const needAdj = brightness !== 0 || contrast !== 0;

      for (let i = 0; i < px.length; i += 4) {
        if (isBg[i / 4]) {
          px[i] = 255; px[i+1] = 255; px[i+2] = 255;
        } else if (needAdj) {
          for (let j = 0; j < 3; j++) {
            let v = px[i+j] + bf;
            v = cf * (v - 128) + 128;
            px[i+j] = Math.max(0, Math.min(255, v));
          }
        }
      }
      ctx.putImageData(d, 0, 0);
      resolve(c.toDataURL("image/jpeg", 0.92));
    };
    img.src = base64;
  });
}
